<style>
    .mat-detail-row {
        padding-left: 55px !important;
    }
</style>
<div style="text-align:center;padding-top:10px" *ngIf="dentalScreenings.length == 0 && hearingScreenings.length == 0 && 
physicalScreenings.length == 0 && spinalScreenings.length == 0 && visionScreenings.length == 0" translate>
    No screening data exists for student
</div>
<!-- <div *ngIf="screening.length > 0">
  <mat-table [dataSource]="angularMatData" multiTemplateDataRows matSortDisableClear matSort matSortActive="ScreeningType"
    matSortDirection="asc" aria-label="Screening Data Table">
    <ng-container matColumnDef="More">
      <mat-header-cell *matHeaderCellDef style="min-width:68px;max-width:68px;text-align:center;" translate>More</mat-header-cell>
      <mat-cell *matCellDef="let s" style="min-width:68px;max-width:68px;text-align:center;">
        <span aria-label="Expand row for more details">
          <i [ngClass]="checkExpanded(s) ? 'detail-row-expanded-icon' : 'detail-row-collapsed-icon'" class="material-icons" aria-hidden="true"></i>
        </span>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="ScreeningType">
      <mat-header-cell *matHeaderCellDef mat-sort-header translate>Screening
        <filter class="mat-filter" [data]="angularMatData" columnName="ScreeningType" dataType="string"></filter>
      </mat-header-cell>
      <mat-cell *matCellDef="let s">{{s.ScreeningType}}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="expandRow">
      <td mat-cell *matCellDef="let s;let i = index;" class="mat-detail-card" [attr.colspan]="displayedScreeningColumn.length">
        <div style="text-align:center;" *ngIf="s.Screenings.length == 0" translate>No screening data exists for student</div>
        <div style="width:100%;" *ngIf="s.Screenings.length > 0">
          <app-screening-detail [screeningdetail]="s.Screenings" [screeningId]="s.Id"></app-screening-detail>
        </div>
      </td>
    </ng-container>

    
    <mat-header-row *matHeaderRowDef="displayedScreeningColumn"></mat-header-row>
    <mat-row *matRowDef="let row;let i= index; columns: displayedScreeningColumn;" (click)="toggleExpanded(row)"
      (keydown)="rowKeyPress($event, row)" [attr.aria-label]="getScreeningAriaRow(row)"></mat-row>
    <mat-row *matRowDef="let row; columns: ['expandRow']" [@detailExpand]="checkExpanded(row)  ? 'expanded' : 'collapsed'"
      style="overflow: hidden" class="mat-detail-row"></mat-row>
  </mat-table>
</div> -->

<div style="padding-top: 10px">
    <div *ngIf="dentalScreenings.length > 0" class="screening-type-header">
        Dental
    </div>
    <div *ngIf="dentalScreenings.length > 0" class="screening-type-grid">
        <mat-table style="width: 100%; display: table;" #table [dataSource]="dentalDataSource" multiTemplateDataRows
            id="dentalTable" aria-label="Dental Table" matSort #dentalSort="matSort" matSortActive="ScreenedOn"
            matSortDirection="desc">

            <!-- ScreeningName -->
            <ng-container matColumnDef="ScreeningName">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span translate>Screening Name</span>
                    <filter [data]="dentalDataSource" columnName="ScreeningName" dataType="string"
                        id="screeningNameFilter" class="mat-filter">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{element.ScreeningName}}
                </mat-cell>
            </ng-container>

            <!-- ScreeningSeries -->
            <ng-container matColumnDef="ScreeningSeries">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span translate>Screening Series</span>
                    <filter [data]="dentalDataSource" columnName="ScreeningSeries" dataType="string"
                        id="screeningSeriesFilter" class="mat-filter">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{element.ScreeningSeries}}
                </mat-cell>
            </ng-container>

            <!-- ScreenedOn -->
            <ng-container matColumnDef="ScreenedOn">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span translate>Screened On</span>
                    <filter [data]="dentalDataSource" columnName="ScreenedOn" dataType="date" id="screeningOnFilter"
                        class="mat-filter">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{element.ScreenedOn | date:'MM/dd/yyyy'}}
                </mat-cell>
            </ng-container>

            <!-- Results -->
            <ng-container matColumnDef="Results">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span translate>Results</span>
                    <filter [data]="dentalDataSource" columnName="Results" dataType="string" id="resultsFilter"
                        class="mat-filter">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{element.Results}}
                </mat-cell>
            </ng-container>

            <!-- ScreeningBy -->
            <ng-container matColumnDef="ScreenedBy">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span translate>Screened By</span>
                    <filter [data]="dentalDataSource" columnName="ScreenedBy" dataType="string" id="ScreenedByFilter"
                        class="mat-filter">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{element.ScreenedBy}}
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="dentalColumnsToDisplay; sticky: true" id="dentalTableHeader">
            </mat-header-row>

            <mat-row *matRowDef="let row; columns: dentalColumnsToDisplay; let i = index;" id="spDataRow{{i}}"
                tabindex="0" style="padding:0px;overflow: hidden;" matRipple>
            </mat-row>

        </mat-table>
    </div>
    <div *ngIf="hearingScreenings.length > 0" class="screening-type-header">
        Hearing
    </div>
    <div *ngIf="hearingScreenings.length > 0" class="screening-type-grid">
        <mat-table style="width: 100%; display: table;" #table [dataSource]="hearingDataSource" multiTemplateDataRows
            id="hearingTable" aria-label="Hearing Table" matSort #hearingSort="matSort" matSortActive="ScreenedOn"
            matSortDirection="desc">

            <!-- ScreeningName -->
            <ng-container matColumnDef="ScreeningName">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span translate>Screening Name</span>
                    <filter [data]="hearingDataSource" columnName="ScreeningName" dataType="string"
                        id="screeningNameFilter" class="mat-filter">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{element.ScreeningName}}
                </mat-cell>
            </ng-container>

            <!-- ScreeningSeries -->
            <ng-container matColumnDef="ScreeningSeries">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span translate>Screening Series</span>
                    <filter [data]="hearingDataSource" columnName="ScreeningSeries" dataType="string"
                        id="screeningSeriesFilter" class="mat-filter">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{element.ScreeningSeries}}
                </mat-cell>
            </ng-container>

            <!-- ScreenedOn -->
            <ng-container matColumnDef="ScreenedOn">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span translate>Screened On</span>
                    <filter [data]="hearingDataSource" columnName="ScreenedOn" dataType="date" id="screeningOnFilter"
                        class="mat-filter">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{element.ScreenedOn | date:'MM/dd/yyyy'}}
                </mat-cell>
            </ng-container>

            <!-- Results -->
            <ng-container matColumnDef="Results">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span translate>Results</span>
                    <filter [data]="hearingDataSource" columnName="Results" dataType="string" id="resultsFilter"
                        class="mat-filter">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{element.Results}}
                </mat-cell>
            </ng-container>

            <!-- ScreeningBy -->
            <ng-container matColumnDef="ScreenedBy">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span translate>Screened By</span>
                    <filter [data]="hearingDataSource" columnName="ScreenedBy" dataType="string" id="ScreenedByFilter"
                        class="mat-filter">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{element.ScreenedBy}}
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="hearingColumnsToDisplay; sticky: true" id="hearingTableHeader">
            </mat-header-row>

            <mat-row *matRowDef="let row; columns: hearingColumnsToDisplay; let i = index;" id="hDataRow{{i}}"
                tabindex="0" style="padding:0px;overflow: hidden;" matRipple>
            </mat-row>

        </mat-table>
    </div>
    <div *ngIf="physicalScreenings.length > 0" class="screening-type-header">
        Physical Exam
    </div>
    <div *ngIf="physicalScreenings.length > 0" class="screening-type-grid">
        <mat-table style="width: 100%; display: table;" #table [dataSource]="physicalDataSource" multiTemplateDataRows
            id="physicalTable" aria-label="Physical Table" matSort #physicalSort="matSort" matSortActive="ScreenedOn"
            matSortDirection="desc">

            <!-- ScreeningName -->
            <ng-container matColumnDef="ScreeningName">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span translate>Screening Name</span>
                    <filter [data]="physicalDataSource" columnName="ScreeningName" dataType="string"
                        id="screeningNameFilter" class="mat-filter">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{element.ScreeningName}}
                </mat-cell>
            </ng-container>

            <!-- ScreeningSeries -->
            <ng-container matColumnDef="ScreeningSeries">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span translate>Screening Series</span>
                    <filter [data]="physicalDataSource" columnName="ScreeningSeries" dataType="string"
                        id="screeningSeriesFilter" class="mat-filter">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{element.ScreeningSeries}}
                </mat-cell>
            </ng-container>

            <!-- ScreenedOn -->
            <ng-container matColumnDef="ScreenedOn">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span translate>Screened On</span>
                    <filter [data]="physicalDataSource" columnName="ScreenedOn" dataType="date" id="screeningOnFilter"
                        class="mat-filter">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{element.ScreenedOn | date:'MM/dd/yyyy'}}
                </mat-cell>
            </ng-container>

            <!-- Results -->
            <ng-container matColumnDef="Results">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span translate>Results</span>
                    <filter [data]="physicalDataSource" columnName="Results" dataType="string" id="resultsFilter"
                        class="mat-filter">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{element.Results}}
                </mat-cell>
            </ng-container>

            <!-- ScreeningBy -->
            <ng-container matColumnDef="ScreenedBy">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span translate>Screened By</span>
                    <filter [data]="physicalDataSource" columnName="ScreenedBy" dataType="string" id="ScreenedByFilter"
                        class="mat-filter">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{element.ScreenedBy}}
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="physicalColumnsToDisplay; sticky: true" id="physicalTableHeader">
            </mat-header-row>

            <mat-row *matRowDef="let row; columns: physicalColumnsToDisplay; let i = index;" id="spDataRow{{i}}"
                tabindex="0" style="padding:0px;overflow: hidden;" matRipple>
            </mat-row>

        </mat-table>
    </div>
    <div *ngIf="spinalScreenings.length > 0" class="screening-type-header">
        Spinal
    </div>
    <div *ngIf="spinalScreenings.length > 0" class="screening-type-grid">
        <mat-table style="width: 100%; display: table;" #table [dataSource]="spinalDataSource" multiTemplateDataRows
            id="spinalTable" aria-label="Spinal Table" matSort #spinalSort="matSort" matSortActive="ScreenedOn"
            matSortDirection="desc">

            <!-- ScreeningName -->
            <ng-container matColumnDef="ScreeningName">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span translate>Screening Name</span>
                    <filter [data]="spinalDataSource" columnName="ScreeningName" dataType="string"
                        id="screeningNameFilter" class="mat-filter">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{element.ScreeningName}}
                </mat-cell>
            </ng-container>

            <!-- ScreeningSeries -->
            <ng-container matColumnDef="ScreeningSeries">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span translate>Screening Series</span>
                    <filter [data]="spinalDataSource" columnName="ScreeningSeries" dataType="string"
                        id="screeningSeriesFilter" class="mat-filter">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{element.ScreeningSeries}}
                </mat-cell>
            </ng-container>

            <!-- ScreenedOn -->
            <ng-container matColumnDef="ScreenedOn">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span translate>Screened On</span>
                    <filter [data]="spinalDataSource" columnName="ScreenedOn" dataType="date" id="screeningOnFilter"
                        class="mat-filter">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{element.ScreenedOn | date:'MM/dd/yyyy'}}
                </mat-cell>
            </ng-container>

            <!-- Results -->
            <ng-container matColumnDef="Results">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span translate>Results</span>
                    <filter [data]="spinalDataSource" columnName="Results" dataType="string" id="resultsFilter"
                        class="mat-filter">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{element.Results}}
                </mat-cell>
            </ng-container>

            <!-- ScreeningBy -->
            <ng-container matColumnDef="ScreenedBy">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span translate>Screened By</span>
                    <filter [data]="spinalDataSource" columnName="ScreenedBy" dataType="string" id="ScreenedByFilter"
                        class="mat-filter">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{element.ScreenedBy}}
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="spinalColumnsToDisplay; sticky: true" id="spinalTableHeader">
            </mat-header-row>

            <mat-row *matRowDef="let row; columns: spinalColumnsToDisplay; let i = index;" id="spDataRow{{i}}"
                tabindex="0" style="padding:0px;overflow: hidden;" matRipple>
            </mat-row>

        </mat-table>
    </div>
    <div *ngIf="visionScreenings.length > 0" class="screening-type-header">
        Vision
    </div>
    <div *ngIf="visionScreenings.length > 0" class="screening-type-grid">
        <mat-table style="width: 100%; display: table;" #table [dataSource]="visionDataSource" multiTemplateDataRows
            id="visionTable" aria-label="Vision Table" matSort #visionSort="matSort" matSortActive="ScreenedOn"
            matSortDirection="desc">

            <!-- ScreeningName -->
            <ng-container matColumnDef="ScreeningName">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span translate>Screening Name</span>
                    <filter [data]="spinalDataSource" columnName="ScreeningName" dataType="string"
                        id="screeningNameFilter" class="mat-filter">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{element.ScreeningName}}
                </mat-cell>
            </ng-container>

            <!-- ScreeningSeries -->
            <ng-container matColumnDef="ScreeningSeries">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span translate>Screening Series</span>
                    <filter [data]="spinalDataSource" columnName="ScreeningSeries" dataType="string"
                        id="screeningSeriesFilter" class="mat-filter">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{element.ScreeningSeries}}
                </mat-cell>
            </ng-container>

            <!-- ScreenedOn -->
            <ng-container matColumnDef="ScreenedOn">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span translate>Screened On</span>
                    <filter [data]="spinalDataSource" columnName="ScreenedOn" dataType="date" id="screeningOnFilter"
                        class="mat-filter">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{element.ScreenedOn | date:'MM/dd/yyyy'}}
                </mat-cell>
            </ng-container>

            <!-- Results -->
            <ng-container matColumnDef="Results">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span translate>Results</span>
                    <filter [data]="spinalDataSource" columnName="Results" dataType="string" id="resultsFilter"
                        class="mat-filter">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{element.Results}}
                </mat-cell>
            </ng-container>

            <!-- ScreeningBy -->
            <ng-container matColumnDef="ScreenedBy">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span translate>Screened By</span>
                    <filter [data]="spinalDataSource" columnName="ScreenedBy" dataType="string" id="ScreenedByFilter"
                        class="mat-filter">
                    </filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{element.ScreenedBy}}
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="visionColumnsToDisplay; sticky: true" id="visionTableHeader">
            </mat-header-row>

            <mat-row *matRowDef="let row; columns: visionColumnsToDisplay; let i = index;" id="vsDataRow{{i}}"
                tabindex="0" style="padding:0px;overflow: hidden;" matRipple>
            </mat-row>

        </mat-table>
    </div>
</div>